<app-cc-vscroll-table
  body #ccTable [transPartKey]="'clearing.trade.selection'"
  [tableConfig]="tableConfig"
  [loading]="tableLoadingCount>0||tableLoading"
  [(selectedIds)]="selectedIds"
  (selectedIdsChange)="selectionChanged($event);"
  [records]="records"
  [totalRecords]="totalRecords"
  [recordIds]="recordIds"
  [disableContextMenu]="true"
  [currentRequest]="tableCurrentRequest"
  [defaultSortField]="tableConfigService.defaultSortField" [defaultSortOrder]="tableConfigService.defaultSortOrder"
  (loadRecordsEvent)="loadRecords($event)"
  (filterChangedEvent)="filterSortChanged()" (sortChangedEvent)="filterSortChanged()"
  scrollHeightNumber="-1"
  [scrollHeightString]="'calc( 45vh - 106px )'"
  [fieldName]="'id'"
  [fieldId]="'id'"
  (onColOrderChange)="colOrderChanged($event)"
>
  <!--  *ngIf="tableCurrentRequest&&tableCurrentRequest.syncMetadata&&tableCurrentRequest.syncMetadata.totalRecord>0"-->
  <ng-container *ngIf="!selectionBase">
    <span caption-left class="ctrl-a-mode-all">{{ ctrlAModeHeadMssg }}</span>
  </ng-container>
  <app-clearing-selection-summary caption-left
                                  [summaryBuyValue]="summaryBuyValue" [summarySellValue]="summarySellValue"
                                  [isDark]="true" [showLoadingSpinner]="true"></app-clearing-selection-summary>
</app-cc-vscroll-table>
